module.exports = __webpack_public_path__ + "static/media/galeria2.b5fc7781.jpg";